export function extractUserMessage(error: unknown) {
    if (error === null) return 'Unknown error (null)';
    switch (typeof error) {
        case 'object': {
            let message: string;
            try {
                message = `${error}`;
            } catch (stringConversionError) {
                // last chance: manually see if it conforms to { message: string }
                if ('message' in error && typeof error.message === 'string') {
                    message = error.message;
                } else {
                    // otherwise who knows
                    message = `Unknown error (string conversion failed: ${String(stringConversionError)}>)`;
                }
            }
            return message || `Unknown error (no message)`;
        }

        case 'string':
            return error || `Unknown error (empty string)`;

        // Throwing string is bad enough; anything else is the weird zone
        case 'undefined':
            return 'Unknown error (undefined)';
        default:
            return `Unknown error (${String(error)})`;
    }
}
